<script setup>
const DefaultLayout = defineAsyncComponent(() => import('./components/DefaultLayout.vue'))
</script>

<template>
  <DefaultLayout />
</template>
